import { efFetch, setLocaleQuery } from '@/utils';
import request from '@/utils/request';
import { baseUrl } from './util';

/*
 * installer near me ==============================
 */

// 查询门店
export const getInstallerStoreList = (params: any, locale: string) => {
    return request.get(`${baseUrl(locale)}/homeStorageInstaller/query`, {
        params,
    });
};

// 查询后台配置的门店总数
export const getInstallerStoreNum = (locale: string) => {
    return request.get(`${baseUrl(locale)}/homeStorageInstaller/queryTotalNum`);
};

// 家储安装商订阅
export const subscribeInstallerStore = (data: any, locale: string) => {
    return request.post(`${baseUrl(locale)}/subscribe/homeNew`, {
        data,
    });
};

// /**
//  * 邮箱订阅new
//  */
// export const subscribeMultiEmarsysEmail = async (locale: string, data: any) => {
//     return request.post(`${loginUrl(locale)}/website/subscribe/new`, {
//         data,
//         headers: {
//             // apiKey: '527760f6df93c0d6e98609fa8e8a1f4a',
//         },
//     });
// };
